export default "__VITE_ASSET__DnplSjvQ__"